<div class="card-body">
    <div id="apex-radialbar-stroked-circular-gauge"></div>
</div>